import { IEntity } from '@pf/shared-common';
import {
    ContactFragment,
    PackingListFragment,
    ProjectLineItemFragment,
    ProjectPriority,
    ProjectSearchRequestParams,
    ProjectStatus,
    ProjectTypeFragment,
    ProjectViewModelCreateBody,
    ProjectViewModelRead,
    ResourceAuth,
    WarehouseFragment,
} from '@control-tower/platform-wms';
import {
    CustomFieldDto,
    getCustomFieldValue,
    ICustomFieldDto,
    ILocationFragmentDto,
    IUserFragment,
} from '@pf/shared/util-platform';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';

export type ProjectRead = ProjectViewModelRead & IEntity;
export type ProjectCreate = ProjectViewModelCreateBody;
export type ProjectSearchParams = ProjectSearchRequestParams;

/**
 * Gets the custom field value holding the SDI work order number on a project.
 */
export function getProjectWorkOrderNumber(
    project: ProjectDto | ProjectRead | null | undefined
): string {
    return (
        getCustomFieldValue(
            project?.customFields as ICustomFieldDto[],
            'Work Order Number'
        ) ||
        project?.number ||
        ''
    );
}

/**
 * Gets the custom field value holding the Walmart order number on a project.
 */
export function getProjectOrderNumber(
    project: ProjectDto | ProjectRead | null | undefined
): string {
    return (
        getCustomFieldValue(
            project?.customFields as ICustomFieldDto[],
            'Order Number'
        ) || ''
    );
}

export class ProjectDto implements IWarehouseEntity {
    constructor(data: Partial<ProjectDto>) {
        Object.assign(this, data);
    }
    id!: string;
    number!: string;
    status!: ProjectStatus;
    priority!: ProjectPriority;
    warehouse!: WarehouseFragment;

    notes?: string | null;
    assignedToUser?: IUserFragment | null;
    startDate?: string | null;
    endDate?: string | null;
    externalReferenceId?: string | null;
    primaryLocation?: ILocationFragmentDto;
    secondaryLocation?: ILocationFragmentDto;
    requestingContact?: ContactFragment;
    projectType?: ProjectTypeFragment;
    lineItems?: Array<ProjectLineItemFragment> | null;
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
    customFields?: CustomFieldDto[];
    packingLists?: Array<PackingListFragment> | null;
    resourceAuth?: ResourceAuth;
}
